<div class="offcanvas-header border-bottom">
  <div>
    <h5 class="offcanvas-title premium-heading mb-1">
      @if (mode === 'ADD') {
        Add payment account
      }
      @if (mode === 'VIEW') {
        Payment Account Detail
      }
      @if (mode === 'EDIT') {
        Edit payment account
      }
    </h5>
    @if (mode === 'ADD') {
      <div class="premium-subtitle">
        Create operational account for Day Book
      </div>
    }
    @if (mode !== 'ADD' && editAccountData) {
      <div class="premium-subtitle text-uppercase">
        {{ editAccountData.accountName || '' }}
      </div>
    }
  </div>
  <button type="button" class="btn-close text-reset shadow-none" aria-label="Close"
    [disabled]="loader" (click)="cancel()"></button>
</div>

<div class="offcanvas-body p-md-3 p-2 bg-light custom-scrollbar">
  <!-- Error Alert -->
  @if (errorMessage) {
    <div class="alert alert-danger py-2 mb-3 small d-flex justify-content-between align-items-center rounded-3">
      <span>{{ errorMessage }}</span>
      <button type="button" class="btn-close small py-1 shadow-none" style="font-size: 0.75rem;"
        (click)="errorMessage = ''"></button>
    </div>
  }

  @if (mode === 'VIEW') {
    <div class="d-flex flex-column gap-3 mt-2">

      <div class="d-flex flex-column gap-1">
        <span class="premium-view-label">Branch</span>
        <span class="premium-view-value-text">{{ editAccountData?.company?.name || '-' }}</span>
      </div>

      <div class="d-flex flex-column gap-1">
        <span class="premium-view-label">Payment mode</span>
        <span class="premium-view-value-text">{{ editAccountData?.paymentType || '-' }}</span>
      </div>

      <div class="d-flex flex-column gap-1">
        <span class="premium-view-label">Account name</span>
        <span class="premium-view-value-text text-uppercase">{{ editAccountData?.accountName || '-' }}</span>
      </div>

      <div class="d-flex flex-column gap-1">
        <span class="premium-view-label">Settlement type</span>
        <span class="premium-view-value-text">
          @if (editAccountData?.settlementType === 'Auto') {
            Delay
          } @else if (editAccountData?.settlementType === 'Immediate') {
            Immediate
          } @else if (editAccountData?.settlementType === 'Manual') {
            Manual
          } @else {
            -
          }
        </span>
      </div>

      @if (editAccountData?.settlementType === 'Immediate' || editAccountData?.settlementType === 'Auto') {
        <div class="d-flex flex-column gap-1">
          <span class="premium-view-label">Balance account</span>
          <span class="premium-view-value-text">{{ editAccountData?.balanceAccountId?.accountName || editAccountData?.balanceAccount?.accountName || '-' }}</span>
        </div>
      }

      @if (editAccountData?.settlementType === 'Auto') {
        <div class="d-flex flex-column gap-1">
          <span class="premium-view-label">Settlement days</span>
          <span class="premium-view-value-text">{{ editAccountData?.settlementPeriod || 0 }}</span>
        </div>
      }

      <div class="d-flex flex-column gap-1">
        <span class="premium-view-label">Status</span>
        <span class="status-label fw-bold" [ngClass]="editAccountData?.status ? 'text-green' : 'text-red'">
          {{ editAccountData?.status ? 'Active' : 'Inactive' }}
        </span>
      </div>
    </div>
  }

  @if (mode === 'ADD' || mode === 'EDIT') {
    <form [formGroup]="accountForm" class="d-flex flex-column gap-2">
      <div>
        <label for="companySelect" class="form-label premium-form-label mb-1">Branch *</label>
        <ng-select labelForId="companySelect" [items]="branches" bindLabel="name" bindValue="_id" formControlName="company"
          [clearable]="false" placeholder="Select a branch" class="custom-ng-select">
        </ng-select>
        @if (accountForm.get('company')?.touched && accountForm.get('company')?.invalid) {
          <div class="text-danger small mt-1">
            @if (accountForm.get('company')?.errors?.['required']) {
              Branch is required
            }
          </div>
        }
      </div>

      <div>
        <label for="paymentTypeSelect" class="form-label premium-form-label mb-1">Payment mode *</label>
        <ng-select labelForId="paymentTypeSelect" [items]="paymentTypes" bindLabel="label" bindValue="key" formControlName="paymentType"
          [clearable]="false" placeholder="Select payment mode" class="custom-ng-select">
        </ng-select>
        @if (accountForm.get('paymentType')?.touched && accountForm.get('paymentType')?.invalid) {
          <div class="text-danger small mt-1">
            @if (accountForm.get('paymentType')?.errors?.['required']) {
              Payment mode is required
            }
          </div>
        }
      </div>

      <div>
        <label for="accountNameInput" class="form-label premium-form-label mb-1">Account name *</label>
        <input type="text" id="accountNameInput" class="form-control premium-input text-uppercase-input" formControlName="accountName" placeholder="e.g. SBI Current" (input)="onAccountNameInput($event)">
        @if (accountForm.get('accountName')?.touched && accountForm.get('accountName')?.invalid) {
          <div class="text-danger small mt-1">
            @if (accountForm.get('accountName')?.errors?.['required']) {
              Account name is required
            }
            @if (accountForm.get('accountName')?.errors?.['maxlength']) {
              Account name cannot exceed 50 characters
            }
          </div>
        }
      </div>

      <div class="mt-2">
        <span class="form-label premium-form-label mb-1 d-block">Balance settlement</span>
        <div class="bottom-label-text mb-2">Immediate and Delayed require a balance account. Manual picks the account when you create a settlement.</div>
        
        <div class="settlement-type-segments d-flex gap-2">
          <button type="button" class="btn segment-btn" [disabled]="accountForm.get('settlementType')?.disabled" [class.active]="accountForm.get('settlementType')?.value === 'Immediate'" (click)="onSettlementTypeChange('Immediate')">Immediate</button>
          <button type="button" class="btn segment-btn" [disabled]="accountForm.get('settlementType')?.disabled" [class.active]="accountForm.get('settlementType')?.value === 'Auto'" (click)="onSettlementTypeChange('Auto')">Delay</button>
          <button type="button" class="btn segment-btn" [disabled]="accountForm.get('settlementType')?.disabled" [class.active]="accountForm.get('settlementType')?.value === 'Manual'" (click)="onSettlementTypeChange('Manual')">Manual</button>
        </div>
      </div>

      @if (accountForm.get('settlementType')?.value === 'Immediate' || accountForm.get('settlementType')?.value === 'Auto') {
        <div>
          <label for="balanceAccountSelect" class="form-label premium-form-label mb-1">Balance account *</label>
          <ng-select labelForId="balanceAccountSelect" [items]="balanceAccounts" bindLabel="accountName" bindValue="_id" formControlName="balanceAccountId"
            [clearable]="false" placeholder="Select balance account" class="custom-ng-select">
          </ng-select>
          @if (accountForm.get('balanceAccountId')?.touched && accountForm.get('balanceAccountId')?.invalid) {
            <div class="text-danger small mt-1">
              @if (accountForm.get('balanceAccountId')?.errors?.['required']) {
                Balance account is required
              }
            </div>
          }
        </div>
      }

      @if (accountForm.get('settlementType')?.value === 'Auto') {
        <div>
          <label for="settlementPeriodInput" class="form-label premium-form-label mb-1">Settlement days *</label>
          <input type="number" id="settlementPeriodInput" min="1" max="7" class="form-control premium-input" formControlName="settlementPeriod" placeholder="e.g. 2">
          @if (accountForm.get('settlementPeriod')?.touched && accountForm.get('settlementPeriod')?.invalid) {
            <div class="text-danger small mt-1">
              @if (accountForm.get('settlementPeriod')?.errors?.['required']) {
                Settlement days is required
              }
              @if (accountForm.get('settlementPeriod')?.errors?.['min'] || accountForm.get('settlementPeriod')?.errors?.['max']) {
                Settlement days must be between 1 and 7
              }
            </div>
          }
          <div class="bottom-label-text mt-1">Number of days after transaction (1 to 7)</div>
        </div>
      }

      @if (mode === 'EDIT') {
        <div class="d-flex align-items-center gap-2 mt-2">
          <label for="statusSwitch" class="form-label premium-form-label m-0">Status</label>
          <div class="form-check form-switch m-0 d-flex align-items-center">
            <input id="statusSwitch" class="form-check-input cursor-pointer switch-blue" type="checkbox" formControlName="status">
            <span class="small ms-2 fw-semibold" [ngClass]="accountForm.get('status')?.value ? 'text-green' : 'text-red'">
              {{ accountForm.get('status')?.value ? 'Active' : 'Inactive' }}
            </span>
          </div>
        </div>
      }
    </form>
  }
</div>

<div class="offcanvas-footer border-top p-3 bg-white d-flex flex-column gap-2">
  @if (mode === 'VIEW') {
    @if (isBranchVisible) {
      <button class="btn premium-btn-dark w-100 py-2" [disabled]="loader"
        (click)="switchToEdit()">Edit payment account</button>
    }
    <button class="btn premium-btn-cancel w-100 py-2" [disabled]="loader"
      (click)="cancel()">Cancel</button>
  }

  @if (mode === 'ADD' || mode === 'EDIT') {
    <button class="btn premium-btn-dark w-100 py-2 d-flex justify-content-center align-items-center gap-2"
      [disabled]="accountForm.invalid || loader" (click)="save()">
        <span>{{ mode === 'ADD' ? 'Save payment account' : 'Save Changes' }}</span>
        @if (loader) {
        <fa-icon [icon]="faSpinner" [animation]="'spin'" class="me-1"></fa-icon>
        }
    </button>
    <button class="btn premium-btn-cancel w-100 py-2" [disabled]="loader"
      (click)="cancel()">Cancel</button>
  }
</div>
